/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_C2Inputs */

const en_guide_json_syntax_errors_c2 = /** @type {(inputs: Guide_Json_Syntax_Errors_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why comments are rejected and what to do instead`)
};

const ko_guide_json_syntax_errors_c2 = /** @type {(inputs: Guide_Json_Syntax_Errors_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석이 거부되는 이유와 그 대신 할 것`)
};

const ja_guide_json_syntax_errors_c2 = /** @type {(inputs: Guide_Json_Syntax_Errors_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントが拒否される理由と代わりにできること`)
};

/**
* | output |
* | --- |
* | "Why comments are rejected and what to do instead" |
*
* @param {Guide_Json_Syntax_Errors_C2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_c2 = /** @type {((inputs?: Guide_Json_Syntax_Errors_C2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_C2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_c2(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_c2(inputs)
	return ja_guide_json_syntax_errors_c2(inputs)
});